"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeprecatedSingleSelect = DeprecatedSingleSelect;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _Field = require("./Field");

var _SelectIndicators = require("./SelectIndicators");

var _reactSelectUtilities = require("../utilities/reactSelectUtilities");

var _selectUtils = require("../utilities/selectUtils");

var _excluded = ["cssClassModifiers", "disabled", "errorMessage", "isValid", "label", "onChange", "reference", "textField", "valueField"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getOptionsInProperFormat(_ref) {
  var options = _ref.options,
      textField = _ref.textField,
      valueField = _ref.valueField;

  if (!options) {
    return [];
  }

  return options.map(function (option) {
    var _ref2;

    return (0, _reactSelectUtilities.isStringAndNotEmpty)(option) ? (_ref2 = {}, _defineProperty(_ref2, textField, option), _defineProperty(_ref2, valueField, option), _ref2) : option;
  });
}

function getValueInProperFormat(_ref3, options) {
  var _ref4;

  var value = _ref3.value,
      textField = _ref3.textField,
      valueField = _ref3.valueField;

  if (!value) {
    return '';
  }

  return options.find(function (option) {
    return option[valueField] === value;
  }) || (_ref4 = {}, _defineProperty(_ref4, textField, value), _defineProperty(_ref4, valueField, value), _ref4);
}

function DeprecatedSingleSelect(props) {
  var styles = (0, _react.useMemo)(function () {
    return (0, _reactSelectUtilities.getReactSelectStyles)(props.styles);
  }, [props.styles]);

  var cssClassModifiers = props.cssClassModifiers,
      disabled = props.disabled,
      errorMessage = props.errorMessage,
      isValid = props.isValid,
      label = props.label,
      onChange = props.onChange,
      reference = props.reference,
      textField = props.textField,
      valueField = props.valueField,
      remainingProps = _objectWithoutProperties(props, _excluded);

  function handleChange(newValue) {
    onChange(!newValue ? newValue : newValue[valueField]);
  }

  var massagedOptions = getOptionsInProperFormat(props);
  var massagedValue = getValueInProperFormat(props, massagedOptions);
  return /*#__PURE__*/_react["default"].createElement(_Field.Field, {
    cssClassModifiers: cssClassModifiers,
    disabled: disabled,
    errorMessage: errorMessage,
    isValid: isValid,
    label: label
  }, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({}, remainingProps, {
    className: "basic-single",
    classNamePrefix: "select",
    components: {
      ClearIndicator: _SelectIndicators.ClearIndicator,
      DropdownIndicator: _SelectIndicators.DropdownIndicator
    },
    getOptionLabel: function getOptionLabel(option) {
      return option[textField];
    },
    getOptionValue: function getOptionValue(option) {
      return option[valueField];
    },
    isDisabled: disabled,
    onChange: handleChange,
    options: massagedOptions,
    ref: reference,
    styles: styles,
    value: massagedValue
  })));
}

DeprecatedSingleSelect.propTypes = {
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string),
  disabled: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  filterOption: _propTypes["default"].func,
  isClearable: _propTypes["default"].bool,
  isSearchable: _propTypes["default"].bool,
  isValid: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  menuPlacement: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])).isRequired,
  placeholder: _propTypes["default"].string,
  reference: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].instanceOf(Object)]),
  styles: _propTypes["default"].instanceOf(Object),
  textField: _propTypes["default"].string,
  valueField: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object])
};
DeprecatedSingleSelect.defaultProps = {
  cssClassModifiers: [],
  disabled: false,
  errorMessage: '',
  filterOption: _selectUtils.defaultFilterOption,
  isClearable: true,
  isSearchable: true,
  isValid: true,
  label: null,
  menuPlacement: 'auto',
  placeholder: '',
  textField: 'textField',
  valueField: 'valueField'
};